export default __webpack_public_path__ + "static/media/usbFlashDrives.cb48a2f9.svg";